import axios from 'axios'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

function Quote() {
  const [isClick, setIsClick] = useState(false);
  const [quote, setQuote] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    address: '',
    city: '',
    country: '',
    shippingTerms: '',
    shippingMethod: '',
    message: '',
  })

  const handleOnChange = (e) => {
    setQuote({ ...quote, [e.target.name]: e.target.value })
  }

  const handleSubmit = () => {
    if (quote.email === '') {
      toast.error('Fill Detail Please!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsClick(false);
      return false;
    }
    setIsClick(true);
    axios.post('api/onlinestore/sendmail', quote).then(res => {
      toast.success('Quote have been Sent Wait For Response!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsClick(false);
    }).catch(err => {
      setIsClick(false);
      console.log(err);
    })
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Request a Quote
          </h1>
          <p className="text-gray-600 mt-2">Fill in the details below and we'll get back to you shortly</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mt-4 rounded-full"></div>
        </div>

        {/* Form Container */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-gradient-to-r from-gray-800 to-gray-700 px-6 py-4">
            <h2 className="text-white text-xl font-semibold">Get Instant Quote</h2>
            <p className="text-gray-300 text-sm">We'll respond within 24 hours</p>
          </div>
          
          <div className="p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Name Field */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>👤</span> Full Name
                </label>
                <input 
                  onChange={handleOnChange} 
                  name='name'
                  value={quote.name}
                  placeholder="Enter your full name"
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none'
                />
              </div>

              {/* Company Name Field */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>🏢</span> Company Name
                </label>
                <input 
                  onChange={handleOnChange} 
                  name='company'
                  value={quote.company}
                  placeholder="Your company name"
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none'
                />
              </div>

              {/* Email Field */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>📧</span> Email Address <span className="text-red-500">*</span>
                </label>
                <input 
                  onChange={handleOnChange} 
                  name='email'
                  value={quote.email}
                  placeholder="you@example.com"
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none'
                />
              </div>

              {/* Phone Field */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>📞</span> Phone Number
                </label>
                <input 
                  onChange={handleOnChange} 
                  name='phone'
                  value={quote.phone}
                  placeholder="+92 XXX XXXXXXX"
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none'
                />
              </div>

              {/* City Field */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>🌆</span> City
                </label>
                <input 
                  onChange={handleOnChange} 
                  name='city'
                  value={quote.city}
                  placeholder="Your city"
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none'
                />
              </div>

              {/* Country Field */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>🌍</span> Country
                </label>
                <select 
                  onChange={handleOnChange} 
                  name='country' 
                  value={quote.country}
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none bg-white cursor-pointer'
                >
                  <option value="">Select Country</option>
                  <option value="Pakistan">Pakistan</option>
                </select>
              </div>

              {/* Shipping Terms */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>📦</span> Shipping Terms
                </label>
                <select 
                  onChange={handleOnChange} 
                  name='shippingTerms' 
                  value={quote.shippingTerms}
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none bg-white cursor-pointer'
                >
                  <option value="">Select Shipping Terms</option>
                  <option value="EXW">EXW</option>
                  <option value="FCA">FCA</option>
                  <option value="FAS">FAS</option>
                  <option value="FOB">FOB</option>
                  <option value="CIF">CIF</option>
                </select>
              </div>

              {/* Shipping Method */}
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>✈️</span> Shipping Method
                </label>
                <select 
                  onChange={handleOnChange} 
                  name='shippingMethod' 
                  value={quote.shippingMethod}
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none bg-white cursor-pointer'
                >
                  <option value="">Select Shipping Method</option>
                  <option value="BY SEA">BY SEA</option>
                  <option value="BY AIR">BY AIR</option>
                  <option value="DHL">DHL</option>
                </select>
              </div>

              {/* Address Field - Full Width */}
              <div className="md:col-span-2 space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>📍</span> Full Address
                </label>
                <textarea 
                  onChange={handleOnChange} 
                  rows={3} 
                  name='address' 
                  value={quote.address}
                  placeholder="Your complete address"
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none resize-none'
                />
              </div>

              {/* Message Field - Full Width */}
              <div className="md:col-span-2 space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <span>💬</span> Comment / Message
                </label>
                <textarea 
                  onChange={handleOnChange} 
                  rows={4} 
                  name='message'
                  value={quote.message}
                  placeholder="Tell us about your requirements..."
                  className='w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 outline-none resize-none'
                />
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-8">
              <button 
                onClick={handleSubmit} 
                disabled={isClick}
                className='w-full bg-gradient-to-r from-gray-800 to-gray-700 hover:from-gray-900 hover:to-gray-800 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed'
              >
                {isClick ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Sending Your Quote...
                  </span>
                ) : '📩 Submit Quote Request'}
              </button>
              <p className="text-xs text-gray-500 text-center mt-4">
                *We respect your privacy. Your information is safe with us.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quote